import { Box, CircularProgress, Link, Typography } from '@mui/material';
import React from 'react';

const DragAndDrop = ({ onClick, handleDragOver, handleDrop, imageLoader }) => {
  return (
    <Box
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      display="flex"
      flexDirection="column"
      height="60px"
      alignItems="center"
      justifyContent="center"
      gap={1.5}
      px={2}
      py={1.25}
      bgcolor="rgba(230, 242, 240, 1)"
      borderRadius="16px"
      border="1px dashed rgba(138, 193, 187, 1)"
      width="100%"
    >
      {!imageLoader ? (
        <Typography
          variant="body1"
          color="rgba(29, 29, 31, 1)"
          fontFamily="Roboto, Helvetica"
          fontWeight={400}
          lineHeight="24px"
        >
          Drag & Drop or{' '}
          <Link
            onClick={onClick}
            color="rgba(0, 121, 107, 1)"
            fontWeight={500}
            lineHeight="24px"
            sx={{ cursor: 'pointer' }}
          >
            Browse
          </Link>{' '}
          Document
        </Typography>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};

export default DragAndDrop;
